import { render, staticRenderFns } from "./CollectionTitle.vue?vue&type=template&id=9e4f7120&"
import script from "./CollectionTitle.vue?vue&type=script&lang=js&"
export * from "./CollectionTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports